module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/3-27.5e5999e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/uploads/3-27.jpg
// module id = ue2T
// module chunks = 3 4